export const name = 'rnApplication';

/**
 * @ngdoc service
 * @name rhino.components.application.service:rnApplication
 * @description Service for managing applications
 */
export default function rnApplication($log, $q, $window, rnRegistry, rnHttp, $rootElement, rnClient) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let service = {
    getAllApps,
    getFullApps,
    getApplication,
    getMiniApps,
    getExternalApps,
    getCurrentAppId,
    setCurrentAppId,
    rebootApp,
    getAppLocName,
  };

  let nbh = true;   // never been here
  let currentAppId = null;

  return service;

  ////////////////

  /**
   * @ngdoc function
   * @name getApplications
   * @methodOf rhino.components.application.service:rnApplication
   * @description Get all apps of all types
   * @param {boolean} [reload] - If false or undefined, use cache
   */
  function getApplications(reload = false) {
    return rnClient.getConfig(!reload)
      .then(clientConfig => {
        let apps = _.get(clientConfig, 'apps.entity', []);
        if (nbh) {
          nbh = !nbh;
          $log.debug('rnApplications.getApplications: ', apps);
        }
        return apps; // TODO we should just return data.apps here.....but we need to first find out if other PrintOS apps
                     // are expecting just data
      });
}

  /**
   * @ngdoc function
   * @name getApplication
   * @methodOf rhino.components.application.service:rnApplication
   * @description Get all apps of all types
   * @param {String} [appId] - appId for application to return
   */
  function getApplication(appId) {
    return getApplications(false).then((apps) => {
      let found = _.find(apps, {appId: appId});
      return found;
    });
  }

  function getAllApps(reload) {
    return getApplications(reload).then(apps => {
      return apps;
    });
  }

  /**
   * @ngdoc function
   * @name getFullApps
   * @methodOf rhino.components.application.service:rnApplication
   * @description Get apps of type 'full'
   * @param {boolean} [reload] - If false or undefined, use cache
   */
  function getFullApps(reload) {
    return getApplications(reload).then(function(apps) {
      return _.filter(apps, {type: 'full'});
    });
  } //getFullApps


  /**
   * @ngdoc function
   * @name getMiniApps
   * @methodOf rhino.components.application.service:rnApplication
   * @description Get apps of type 'mini'
   * @param {boolean} [reload] - If false or undefined, use cache
   */
  function getMiniApps(reload) {
    return getApplications(reload).then(function(apps) {
      return _.filter(apps, {type: 'mini'});
    });
  } //getMiniApps

  /**
   * @ngdoc function
   * @name getExternalApps
   * @methodOf rhino.components.application.service:rnApplication
   * @description Get apps of type 'external'
   * @param {boolean} [reload] - If false or undefined, use cache
   */
  function getExternalApps(reload) {
    return getApplications(reload).then(function(apps) {
      return _.filter(apps, {type: 'external'});
    });
  } //getExternalApps

  /**
   * @ngdoc function
   * @name rebootApp
   * @methodOf rhino.components.application.service:rnApplication
   * @description Reboot the entire front-end.. This is a hard reload of the client side application
   * @param {boolean} [goHome=false] Force the browser to load '/' on the primary server if true, else just reload the existing route
   */
  function rebootApp(goHome = false) {
    $log.debug('Rebooting Application!!');
    if (goHome === true) {
      rnRegistry.getUrl('sms_portal', 'home')
        .then(function (url) {
          $window.location.href = url;
        });
    } else {
      $window.location.reload();
    }
  }

  /**
   * @ngdoc function
   * @name getCurrentAppId
   * @methodOf rhino.components.application.service:rnApplication
   * @description Returns the current application id by inspecting the `ng-app` attribute.
   * @returns {String|undefined} current application id or undefined if it couldn't be determined
   */
  function getCurrentAppId() {
    if(currentAppId) {
      return currentAppId;
    }

    let appId = $rootElement.attr('ng-app') || $rootElement.attr('data-ng-app');
    if(!appId) {
      $log.info("Can't find current app id");
    }
    return appId;
  }

  function setCurrentAppId(appId) {
    currentAppId = appId;
  }

  function getAppLocName(appId) {
    return getApplications(false).then(apps => {
      let found = _.find(apps, {appId: appId});
      if (found) {
        return found.loc.name;
      }
      else {
        return $q.reject("App not found (" + appId + ")");
      }
    });
  }

} //rnApplication
